import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UiLandingComponent } from './Design/pages/ui-landing/ui-landing.component';
import { UiProfileComponent } from './Design/pages/ui-profile/ui-profile.component';
import { UiEditDetailsComponent } from './Design/pages/ui-edit-details/ui-edit-details.component';
import { EditPersonalDetailsComponent } from './components/edit-personal-details/edit-personal-details.component';
import { UiOnboardingComponent } from './Design/pages/ui-onboarding/ui-onboarding.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { UiListingComponent } from './Design/pages/ui-listing/ui-listing.component';
import { UiBusinessDetailComponent } from './Design/pages/ui-business-detail/ui-business-detail.component';
import { UiGalleryComponent } from './Design/pages/ui-gallery/ui-gallery.component';
import { OnboardingComponent } from './components/onboarding/onboarding.component';
import { PersonalDetailsComponent } from './components/personal-details/personal-details.component';
import { AuthGuard } from './shared/auth/auth.guard';
import { BusinessDetailComponent } from './components/business-detail/business-detail.component';
import { ListingComponent } from './components/listing/listing.component';
import { GalleryComponent } from './components/gallery/gallery.component';
import { UiPostComponent } from './Design/pages/ui-post/ui-post.component';
import { UiAllArticlesComponent } from './Design/pages/ui-all-articles/ui-all-articles.component';
import { ArticleEditComponent } from './components/Article/article-edit/article-edit.component';
import { AllArticlesComponent } from './components/Article/all-articles/all-articles.component';
import { ArticlePreviewComponent } from './components/Article/article-preview/article-preview.component';
import { RenderWebViewComponent } from './components/render-web-view/render-web-view.component';
import { WhyHungeryComponent } from './components/why-hungery/why-hungery.component';
import { PricingComponent } from './components/pricing/pricing.component';
import { GetInTouchComponent } from './components/get-in-touch/get-in-touch.component';
import { PersonalizePlanComponent } from './components/personalize-plan/personalize-plan.component';
import { LoginModalComponent } from './components/login-modal/login-modal.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy/privacy-policy.component';
import { PreRegistrationReviewComponent } from './components/pre-registration-review/pre-registration-review.component';
import { MiniMenuSiteComponent } from './components/mini-menu-site/mini-menu-site.component';
import { miniMenuHostRootMatcher, miniMenuHostSlugMatcher } from './mini-menu-host';
import { WhyHungeryExternalComponent } from './why-hungery-external/why-hungery-external.component';


const routes: Routes = [
  // { path: 'home', component: HomeComponent, canActivate: [AuthGuard], data: { expectedRoles: ['USER'] } },
  // { path: 'admin', component: AdminComponent, canActivate: [AuthGuard], data: { expectedRoles: ['ADMIN'] } },
  { path: 'mini-menu/:slug', component: MiniMenuSiteComponent, data: { miniMenu: true } },
  { matcher: miniMenuHostRootMatcher, component: MiniMenuSiteComponent, data: { miniMenu: true } },
  { matcher: miniMenuHostSlugMatcher, component: MiniMenuSiteComponent, data: { miniMenu: true } },
  { path: '', component: DashboardComponent },
  { path: 'why-hungery', component: WhyHungeryExternalComponent },
  { path: 'pricing', component: PricingComponent },
  { path: 'get-in-touch', component: GetInTouchComponent },
  { path: 'personalize-plan', component: PersonalizePlanComponent },
  { path: 'login-modal', component: DashboardComponent },
  {
    path: 'ui-dashboard',
    component: UiLandingComponent,
  },
  {
    path: 'ui-profile',
    component: UiProfileComponent,
  },
  {
    path: 'ui-edit-details',
    component: UiEditDetailsComponent,
  },
  {
    path: 'ui-onboarding',
    component: UiOnboardingComponent,
  },
  {
    path: 'ui-listing',
    component: UiListingComponent,
  },
  {
    path: 'ui-business-detail',
    component: UiBusinessDetailComponent,
  },
  {
    path: 'ui-gallery',
    component: UiGalleryComponent,
  },
  {
    path: 'edit-personal-details',
    canActivate: [AuthGuard],
    component: EditPersonalDetailsComponent,
  },
  {
    path: 'onboarding',
    canActivate: [AuthGuard],
    component: OnboardingComponent,
  },
  {
    path: 'onboarding/:branchId',
    canActivate: [AuthGuard],
    component: OnboardingComponent,
  },
  {
    path: 'personal-details',
    canActivate: [AuthGuard],
    component: PersonalDetailsComponent,
  },
  {
    path: 'business-detail',
    // canActivate: [AuthGuard],
    component: BusinessDetailComponent,
  },
  {
    path: 'business-detail/:id',
    // canActivate: [AuthGuard],
    component: BusinessDetailComponent,
  },
  {
    path: 'listing',
    component: ListingComponent,
  },
  {
    path: 'gallery',
    //canActivate: [AuthGuard],
    component: GalleryComponent,
  },
  {
    path: 'gallery/:id',
    //canActivate: [AuthGuard],
    component: GalleryComponent,
  },
  {
    path: 'ui-post',
    component: UiPostComponent,
  },
  {
    path: 'article-edit/:articleId',
    canActivate: [AuthGuard],
    component: ArticleEditComponent,
  },
  {
    path: 'article-edit',
    canActivate: [AuthGuard],
    component: ArticleEditComponent,
  },
  {
    path: 'ui-all-articles',
    component: UiAllArticlesComponent,
  },
  {
    path: 'articles/:type',
    canActivate: [AuthGuard],
    component: AllArticlesComponent,
  },
  {
    path: 'article-preview/:isMyArticle/:articleId',
    canActivate: [AuthGuard],
    component: ArticlePreviewComponent,
  },
  {
    path: 'render-web-view/:targatePage',
    component: RenderWebViewComponent,
  },
  {
    path: 'instagram-callback',
    component: LoginModalComponent
  },
  {
    path: 'insta-callback',
    component: LoginModalComponent
  },
  {
    path: 'privacy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'pre-registration',
    canActivate: [AuthGuard],
    component: OnboardingComponent,
  },
  {
    path: 'pre-registration-review',
    canActivate: [AuthGuard],
    component: PreRegistrationReviewComponent,
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 0]
    })
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
